import { makeAutoObservable } from 'mobx'
import { openApi } from '../../../helpers/request'
import { FormEvent } from 'react'
import { notification } from 'antd'
import i from '../../../translations/i'
import __select from "../../../helpers/select_entity/__select.controller";
import { __cpl } from "../../catalog/custom_product_lists/__cpl";

class PushTemplatesController {

    templates: any[] = []
    template: any = {
        enabled: true
    }
    form: any = {}

    pagination = {
        limit: 1000,
        offset: 0,
        count: 0,
    }

    vars = []

    constructor() {
        makeAutoObservable(this)
    }

    getForm(type: string) {
        openApi('get', `/pushes/templates/form/${type}`)
            .then(result => {
                console.log(result)
                this.form = result.data.form
                this.vars = result.data.vars
                this.template.type = type

                // «Зацикленный»: день недели по умолчанию показывается в списке, но сам в шаблон не попадает,
                // и без этой строки сохранение новой настройки ушло бы без дня недели
                if (type === 'recurring' && !this.template.id && !this.template.weekday) {
                    this.template.weekday = result.data.form?.weekday?.enums?.[0]?.value
                }
            })
    }

    getTemplates() {
        openApi('get', '/pushes/templates')
            .then(result => {
              console.log(result)
                this.templates = result.data
            })
    }

    getTemplate(id: number) {
        openApi('get', `/pushes/templates/${id}`)
            .then(result => {
              let data = result.data
              __select.setRefer(data.refer)
              delete data.refer
              delete data.refer_id
              console.log(data)
              this.template = data
              this.getForm(data.type)
            })
    }

    uploadTemplate(image: any) {
        this.template.image = image
        return false
    }

    delete(id: number) {
        openApi('delete', `/pushes/templates/${id}`)
            .then(result => {
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit'),
                })
                this.getTemplates()
            })
            .catch(error => {
                console.log(error)
            })
    }

    deleteImageFromTemplate() {
        let uri = `/pushes/templates/image`
        if(this.template.image && this.template.image.id > 0) uri = `${uri}/${this.template.image.id}`

        openApi('delete', uri)
            .then(result => {
                this.template.image = null
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit'),
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    save(e: FormEvent) {
        e.preventDefault()

        const data = new FormData()

        Object.keys(this.template).map(key => {
            data.append(key, this.template[key])
        })

      if(__select.select.type !== '') {
        data.append('refer_type', __select.select.type)

        if(__select.select.type === 'custom_product_list'){
          if(__cpl.selectedLists[0] > 0) {
            console.log('refer_id')
            data.append('refer_id', __cpl.selectedLists[0])
          } else {
            // hasError = true
          }
        } else {
          if(__select.select.value || (__select.select.type === 'category' && __select.select.value === '')) {
            if(__select.select.type === 'url' || __select.select.type === 'url_blank'){
              data.append('refer_value', __select.select.value)
            } else {
              data.append('refer_id', __select.select.value)
            }
          }
        }
      }

        let uri = `/pushes/templates`
        if(this.template.id > 0) uri = `${uri}/${this.template.id}`

        openApi('post', uri, data, { key: 'Content-Type', value: 'multipart/form-data' })
          .then(result => {
              if(this.template.id && this.template.id > 0) {
                  this.getTemplate(this.template.id)
                  notification.success({
                      message: i.t('def:success.complete'),
                      description: i.t('def:success.edit'),
                  })
              } else {
                  window.location.href = `/pushes/templates`
              }
          })
          .catch(error => {
            console.log(error.response)
            notification.error({
              message: i.t('def:errors.error'),
              description: error.response.data.data.message
            })
          })
    }

}

export default new PushTemplatesController()